import { render } from "./ObjectInfo.vue?vue&type=template&id=0e0b422a&scoped=true"
import script from "./ObjectInfo.vue?vue&type=script&lang=js"
export * from "./ObjectInfo.vue?vue&type=script&lang=js"

import "./ObjectInfo.vue?vue&type=style&index=0&id=0e0b422a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0e0b422a"

export default script